import { TableField, defaultCpfCnpjFormatter, defaultDateFormatter } from "../table-field";

export const fieldsImpedidos: TableField[] = [
  {
    key: "TpPessoa",
    label: "Tipo de Pessoa",
    tdClass: "align-middle",
    thClass: "text-center quebrarPorPalavraHard",
    sortable: false,
  },
  {
    formatter: defaultCpfCnpjFormatter,
    key: "NrCpfcnpj",
    label: "CPF / CNPJ",
    tdClass: "align-middle naoQuebrar",
    thClass: "text-center",
    sortable: false,
  },
  {
    key: "NmNome",
    label: "Nome",
    tdClass: "align-middle quebrarPorPalavraHard",
    thClass: ["text-center", "naoQuebrar"],
    sortable: false,
  },
  {
    key: "DeFundamento",
    label: "Fundamento",
    tdClass: "align-middle quebrarPorPalavraHard",
    thClass: "text-center naoQuebrar",
    sortable: false,
  },
  {
    key: "DeBaselegal",
    label: "Base Legal",
    tdClass: "align-middle quebrarPorPalavraHard",
    thClass: "text-center quebrarPorPalavraHard",
    sortable: false,
  },
  {
    key: "DtInicioimpedimento",
    label: "Início Proibição",
    tdClass: "align-middle naoQuebrar",
    thClass: "text-center quebrarPorPalavraHard",
    sortable: false,
    formatter: defaultDateFormatter,
  },
  {
    key: "DtFimimpedimento",
    label: "Fim Proibição",
    tdClass: "align-middle naoQuebrar",
    thClass: "text-center quebrarPorPalavraHard",
    sortable: false,
    formatter: defaultDateFormatter,
  },
  {
    key: "deAnoNroProtocolo",
    label: "Protocolo TCE/SE",
    tdClass: "align-middle naoQuebrar",
    thClass: "text-center quebrarPorPalavra",
    sortable: false,
  },
  {
    key: "suspensao.DtSuspensao",
    label: "Suspensão",
    tdClass: "align-middle naoQebrar",
    thClass: "text-center naoQuebrar",
    sortable: false,
    formatter: (dt: Date): string => (dt ? dt.toLocaleDateString() : "--"),
  },
  {
    key: "NomeUg",
    label: "Unidade Gestora",
    tdClass: "align-middle quebrarPorPalavraHard",
    thClass: "text-center quebrarPorPalavraHard",
    sortable: false
  },
  {
    key: "actions",
    label: "Ações",
    tdClass: ["align-middle", "col-actions"],
    thClass: "text-center",
    sortable: false,
  },
];
